<template>
<div id = "container" :class="'homepage '+homepageClass">
    <div class="bg">
      <lazy-component>
        <div :class="'bgc '+img.class" v-for="img in imgList" :key="img.class"  v-lazy:background-image="img.url"></div>
      </lazy-component>
    </div>
    <div class="head">
        <div class="userinfo_ship">
            <UserInfo :nickname="true" :avatar="true"></UserInfo>
        </div>
        <img src="../../static_niunai/img/myorder.png" alt="我的订单" class="myorder" @click="myOrder" v-if="orderTime">
        <div class="myorder" v-if="goTime">
          <img src="../../static_niunai/img/myorder_go.png" alt="我的订单" class="myorderPic" @click="myOrder">
          <div class="circlePoint" v-if="circlePointShow"></div>
        </div>
        <div class="videoContainer" v-if="goTime">
          <ActVideo
            :vid="video.vid"
            :poster="video.poster"
            :autoplay="false"
            width="6.07rem"
          ></ActVideo>
        </div>
        <van-submit-bar
          v-if="orderTime"
          button-text="我要预约"
          :label ="'订金'"
          :price="2000"
          @submit="order"
          class="order"
          >
          </van-submit-bar> 
          <van-submit-bar
          v-if="goTime"
          :button-text="gobuttonText"
          @submit="go"
          class="go"
          >                

        </van-submit-bar>           
        <!-- <img class="share" src="../../static_niunai/img/share.png" alt="" @click.prevent="click_share_btn"/>
        <div :class="'giftProgress '+progressShow">
              <div class="textContainer">今日限量版礼品只剩<span class="quantities">{{giftLeft}}</span>份</div>
              <div class="progressContainer">
                  <van-progress :percentage="progress" color="#ffc90d" :show-pivot="isShowProgressText"/>
              </div>
              
        </div> -->
    </div>
</div>
</template>
<script>
import setTitle from "../tools/set-title";
import { setShare } from "../tools/mgtv/share";
import click_handler from "../tools/mgtv/click";
import { page_view, click_event } from "../tools/mgtv/analysis";
import Vue from "vue";
import preload from "../tools/preload";
import download from "../tools/mgtv/downapp";

import to_casher from "../tools/mgtv/casher";
import ActVideo from "../components/common/ActVideo.vue";
import UserInfo from "../components/common/UserInfo.vue";
import { vote, fetch_my_sign_info, fetch_sign_rank } from "../api";
import { getOnline, getTop100Left, getCurrTime } from "../api/getData";
import { Button, Toast, Progress,Lazyload  } from "vant";
import { login, logout } from "../tools/mgtv/login";
import {mapState, mapActions} from 'vuex'
import {imgBaseUrl} from "../api/env"
import {
ACT_P_ORDER,
ACT_ORDER,
ACT_E_ORDER,
ACT_P_GO,
ACT_GO,
ACT_E_GO
} from '../constant/act_stat'
import { wx } from "../api/pay";
import { giftQuantity } from '../constant/products';
Vue.use(Button)
  .use(Toast)
  .use(Progress)
  .use(Lazyload);
export default {
  name: "Homepage",
  props: {},
  components: { UserInfo, ActVideo },
  created() {
    //      preload([]);
  },
  mounted() {
    this.initPage()
    // setTimeout(() => {
    //   setShare(window.rootdata.share);
    // }, 500);
    console.log("this.urlParams",this.urlParams)
    page_view('首页',this);
    preload([
      // "//vipcdn.mgtv.com/upload/20180127/share_weixin2.png",
      // "//vipcdn.mgtv.com/upload/20180408/btn.png",
      // "//vipcdn.mgtv.com/upload/20180408/close.png"
    ]);
  },
  data: function() {
    return {
      now: "",
      isShowProgressText: false,
      goshow: "",
      // ticket: "VXTW3337XHIEVRVU4E0C"
      imgBaseUrl:imgBaseUrl
    };
  },
  computed: {
    ...mapState([
            'actInfo',
            'userInfo',
            'deviceInfo',
            'ticket',
            'urlParams',
            'goStyle',
            'imgList',
            'progress',
            'progressShow',
            'orderList',
            'video'
        ]),
    orderTime: function() {
      return this.$store.getters.orderTime
    },
    goTime: function() {
      return this.$store.getters.goTime
    },
    giftLeft: function() {
      return giftQuantity - this.progress;
    },
    homepageClass: function() {      
      return this.goTime?"goHomePage":"orderHomePage"
    },
    gobuttonText: function() {      
      return this.goStyle?"支付尾款":"立即支付"
    },    
    circlePointShow:function(){
      return this.orderList
    }
  },
  watch:{
    // actInfo(curVal,oldVal){
    //   if(curVal){
    //     console.log("watch [actInfo]:",curVal)
    //     this.initPage();
    //   }
    // }
    // ,
    giftLeft(curVal,oldVal) {
    }
  },
  methods: {
    ...mapActions([
      'requestLogin',
      'getActInfo',
      'getGift',
      'getOrderList',
    ]),
    initPage() {
      this.getOnline();
      // this.getGift(); 
      this.getOrderList();     
      console.log("Index 初始化")
      console.log("this.orderTime:",this.orderTime)
      console.log("this.goTime:",this.goTime)
      this.getActInfo().then(()=>{
        let msg ="";
        if(this.actInfo.progress==ACT_P_ORDER)
        {
          msg = '活动尚未开始，敬请期待！'
        }
        else if(this.actInfo.progress==ACT_E_GO){
          msg = '活动已结束，感谢您的参与！'
        }
        if(msg!="")
          this.$dialog.alert({
              message: msg
            }).then(()=>{}).catch(() => {
              console.log('取消')
            });
      }).catch(error=>{
         console.log("getActInfo reject")
      })
      
      if(this.goTime){
        this.goshow = "goshow";
      }
    },
    getOnline() {
      getOnline().then(res => {
        if (res && res.err == 0) {
          setTimeout(()=>{
          Toast({ message: `<div class='online'><img src='static_niunai/img/icon_online.png'>当前有<span>${res.data}</span>人在浏览</div>`, position: "middle",duration:3000,type:"html" });
          },3000);
        }
      });
    },
    order() {
      click_handler(
        "首页-我要预约",
        () => {
          this.$router.push({
            path: `/OrderDetail`,
            query: this.$route.query
          });
        },
        {
          need_login: true,
          need_act: true,
          login:this.requestLogin
        },
        this);
    },
    go() {
      click_handler(
        "首页-立即支付",
        () => {
          this.$router.push({
            path: `/AddressConfirm`,
            query: this.$route.query
          });
        },
        {
          need_login: true,
          need_act: true,
          login:this.requestLogin
        }
        ,
        this);
    },
    
    
    
    click_share_btn() {
      click_handler(
        "首页-分享按钮",
        () => {
          window.$share_dialog.show();
        },
        {
          need_login: false,
          need_act: false,
          need_vip: false
        },
        this);
    },
    myOrder(){
      click_handler('我的订单', () => {
        this.$router.push({
            path: `/OrderList`,
            query: this.$route.query
          });
        },
        {
          need_login: true,
          need_act: true,
          login:this.requestLogin
        }
        ,
        this);
    }
  }
};
</script>
<!--
-->
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" >

.order .van-submit-bar__bar, .go .van-submit-bar__bar {
  height: 1.256944444rem;
  height: 1.14rem;
  width:7.5rem;
  margin:0 auto;
}
.go .van-submit-bar__bar .van-button {
  background-image linear-gradient(-180deg, #FFEBA4 3%, #E0B580 100%)
  border:none
  color black
  letter-spacing 0.15em
}
.homepage {
  width 7.5rem
  // height 86.32638889rem
  .van-submit-bar {
    width 100%
    margin 0 auto
    .van-submit-bar__bar {
      // height 100%;
      .van-submit-bar__price {
        text-align: center;
        font-size: 0.28rem;

        .van-submit-bar__price-integer {
          font-size: 0.6rem;

          &:first-letter {
            font-size: 0.28rem;
            margin: 0 0.1rem;
          }
        }

        .van-submit-bar__price-decimal {
          font-size: 0.6rem;
        }
      }
    }

    .van-button {
      font-size: 0.36rem;
      flex: 1;
    }
  }

  .go {
    // bottom: -3rem;

    .van-submit-bar__price {
      flex: 0;
      padding-right: 0;
    }
  }

  .goshow {
    bottom: 0;
  }
}

.head {
}

.userinfo_ship {
  position: fixed;
  top: 0.33rem;
  right: 0.2rem;
}

.video_ship {
  position: absolute;
  width: 6.3rem;
  top: 6.5rem;
  left: 0.6rem;
}

.bottom {
  position: fixed;
  bottom: 0;
}

.ruler {
  position: absolute;
  top: 4rem;
  left: 0.5rem;
}

.share {
  position: fixed;
  z-index: 2;
  width: 1.05rem;
  height: 1rem;
  top: 5rem;
  right: 0;
  display :none
}

.giftProgress {
  position: fixed;
  z-index: -1;
  bottom: 1.5rem;
  right: -8rem;
  width: 4.472222rem;
  height: 1.097222rem;
  margin: 0 auto;
  background: url('../../static_niunai/img/gift.png') no-repeat;
  background-size: 100% 100%;
  padding: 0.12rem 0.3rem 0 1rem;

  .textContainer {
    font-size: 0.26rem;
    color: #ffffff;
    position:relative;
    top:0.1rem;
    .quantities {
      color: #ffc90d;
    }
  }

  .progressContainer {
    display: block;
    width: 2.8rem;
    height: 0.45rem;
    position: absolute;
    bottom: 0rem;
  }
}
.progressShow{z-index:2;
bottom: 1.5rem;
  right: 1.5rem;
}
.van-submit-bar__tip {
  background: transparent;
}
.online
  width 4.7rem
  // height 0.65rem  
  padding 0.1rem 
  line-height 0.49rem
  border-radius 0.65rem
  img
    width 0.48rem
    height 0.49rem
    vertical-align middle
    margin-right 0.5rem
  span 
    color #ca8610
.van-toast
  border-radius: 0.65rem;
  background-color #090909
.myorder
    position fixed
    z-index 2
    width 1.03rem
    height 1.12rem
    top 1.6rem
    right 0.2rem
    cursor pointer
.share
    position fixed
    z-index 2
    width 1.05rem
    height 1rem
    top 3rem
    right 0.2rem
    cursor pointer
.van-button
    cursor pointer
.homepage 
  .bg
    width 100%
    .bgc
      width 100%
      width 7.5rem
      // float left
      img
        display block
        height: 100%;
        width: 100%;
        width 7.5rem
        vertical-align:middle;
        margin-top -1px
    div 
      height auto
    .bg1 
      // background: url('../../static_niunai/img/1.jpg') no-repeat;
      background-size 100% 100%
      height 14.87rem
    .bg2 
      // background: url('../../static_niunai/img/2.jpg') no-repeat;
      background-size 100% 100%
      height 4.36rem
    .bg3
      // background: url('../../static_niunai/img/3.jpg') no-repeat;
      background-size 100% 100%
      height 13.7rem
    .bg4 
      // background: url('../../static_niunai/img/4.jpg') no-repeat;
      background-size 100% 100%
      height 19.68rem
    .bg5 
      // background: url('../../static_niunai/img/5.jpg') no-repeat;
      background-size 100% 100%
      height 7.52rem
    .bg6 
      // background: url('../../static_niunai/img/6.jpg') no-repeat;
      background-size 100% 100%
      height 12.76rem
    .bg7 
      // background: url('../../static_niunai/img/7.jpg') no-repeat;
      background-size 100% 100%
      height 7.88rem
    .bg8 
      // background: url('../../static_niunai/img/8.jpg') no-repeat;
      background-size 100% 100% 
      height 6.42rem
    .bg9 
      // background: url('../../static_niunai/img/9.jpg') no-repeat;
      background-size 100% 100%
      height 7.01rem

.orderApp
  .homepage 
    .bg
      width 100%
      div
        height auto
      .b_1 
        background: url('../../static_niunai/img/b1.jpg') no-repeat;
        background-size 100% 100%
      .b_2 
        background: url('../../static_niunai/img/b2.jpg') no-repeat;
        background-size 100% 100%
      .b_3
        background: url('../../static_niunai/img/b3.jpg') no-repeat;
        background-size 100% 100%
      .b_4 
        background: url('../../static_niunai/img/b4.jpg') no-repeat;
        background-size 100% 100%
      .b_5 
        background: url('../../static_niunai/img/b5.jpg') no-repeat;
        background-size 100% 100%
      .b_6 
        background: url('../../static_niunai/img/b6.jpg') no-repeat;
        background-size 100% 100%
      .b_7 
        background: url('../../static_niunai/img/b7.jpg') no-repeat;
        background-size 100% 100%
      

.goApp 
  .userinfo_ship 
    position: fixed;
    top: 0.24rem;
    right: 0.06rem;
    z-index 2
    width 1.11rem
    height 1.17rem
    .nickname
      background-image linear-gradient(-180deg, #FFEBA4 3%, #E0B580 100%)
      color #0d0c15
      margin-top -0.15rem
      width 0.99rem
      height 0.38rem
      line-height 0.38rem
    .avatar
      width 0.86rem
      height 0.86rem
      border: 2px solid #f0dca7;
  .myorder
      position fixed
      z-index 2
      width 1.11rem
      height 1.15rem
      top 1.48rem
      right 0.09rem
      cursor pointer
      img 
        width 100%
        heihgt 100%
      .circlePoint
        position absolute
        width 0.2rem
        height 0.2rem
        top 0.62rem
        right 0.04rem
        background-color red
        border-radius 0.2rem
        z-index 3
  .videoContainer{
    position absolute
    top 15.17rem
    left 0.74rem
    width 6.07rem
    height 3.42rem
  }

  
</style>



// WEBPACK FOOTER //
// src/pages/Index.vue